import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import pushToAnalytics from '../../../lib/analytics';
import { aopAnalyticsSteps } from '../../../lib/analyticsHelper';

const RestrictedMarginTseuModal = (props) => {
  const {
    onClose,
    applicationId,
    authToken,
    accountType,
    registration,
  } = props;

  const publishAnalytics = (stepName) => {
    pushToAnalytics(stepName, {
      applicationId,
      authToken,
      accountType,
      registration,
    });
  };

  const closeModal = () => {
    onClose();
    publishAnalytics(aopAnalyticsSteps.TSEU_MARGIN_ACCESS_DISCLOSURE_CLOSED.name);
  };

  publishAnalytics(aopAnalyticsSteps.TSEU_MARGIN_ACCESS_DISCLOSURE_DISPLAYED.name);

  return (
    <Modal
      show
      onHide={closeModal}
      backdrop
      centered
      className="options-submit-modal"
    >
      <div className="options-submit-modal-div">
        <Modal.Header closeButton id="options-modal-title">
          <h1 id="page-header" className="h1_secondary">
            Margin Access Requires Professional Client Status
          </h1>
        </Modal.Header>
        <div>
          <Modal.Body className="options-submit-modal-body">
            <p className="panel-question">
              In order to enable an account for margin trading, you must first open and fund a cash account and
              subsequently register as a “Professional Client” with TradeStation Europe through a separate process.
              For more information, please&nbsp;
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.tradestation.com/contact-us/"
              >
                contact us.
              </a>
            </p>
          </Modal.Body>
          <Modal.Footer>
            <div className="text-center">
              <button
                type="button"
                className="btn btn-raised btn-default back-button do_capitalize options-submit-modal-button"
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </Modal.Footer>
        </div>
      </div>
    </Modal>
  );
};

RestrictedMarginTseuModal.propTypes = {
  onClose: PropTypes.func,
  applicationId: PropTypes.string,
  authToken: PropTypes.string,
  accountType: PropTypes.shape(),
  registration: PropTypes.shape(),
};

export default RestrictedMarginTseuModal;
